import React, { useState } from 'react';
import { logAuditAction } from '../utils/auditLogger';
import './styles/PanelExcepciones.css';

const COLOR_OPTIONS = [
  { value: '#E24B4A', label: 'Excepción' },
  { value: '#BA7517', label: 'Advertencia' },
  { value: '#185FA5', label: 'Info' },
  { value: '#534AB7', label: 'Especial' },
  { value: '#3B6D11', label: 'OK' },
  { value: '#888780', label: 'Neutro' },
];

const parseCoord = val =>
  parseFloat(typeof val === 'string' ? val.replace(',', '.') : val);

const PanelExcepcion = ({
  hostsDisponibles,
  demoExcepciones,
  setDemoExcepciones,
  CreateCisModalOpen,
}) => {
  const [selectedHost, setSelectedHost] = useState('');
  const [etiquetaTexto, setEtiquetaTexto] = useState('');
  const [colorEtiqueta, setColorEtiqueta] = useState(COLOR_OPTIONS[0].value);
  const [isCollapsed, setIsCollapsed] = useState(false);

  /* ── Crear excepción ──────────────────────────── */
  const crearEtiqueta = () => {
    if (!selectedHost || !etiquetaTexto)
      return alert('Selecciona un host e ingresa un texto');

    if (etiquetaTexto.length > 7)
      return alert('La etiqueta debe tener un máximo de 7 caracteres');

    const yaExiste = demoExcepciones.some(ex => ex.id.startsWith(`excep-${selectedHost}-`));
    if (yaExiste) return;

    const infoHost = hostsDisponibles.find(h => h.hostid == selectedHost);

    const nuevaExcepcion = {
      id: `excep-${selectedHost}-${Date.now()}`,
      type: 'Feature',
      properties: {
        label: etiquetaTexto.toUpperCase(),
        color: colorEtiqueta,
        hostName: infoHost.Host,
      },
      geometry: {
        type: 'Point',
        coordinates: [
          parseCoord(infoHost.longitude),
          parseCoord(infoHost.latitude),
        ],
      },
    };

    setDemoExcepciones([...demoExcepciones, nuevaExcepcion]);
    setEtiquetaTexto('');
    setSelectedHost('');
    logAuditAction("Crear", `Excepción '${etiquetaTexto.toUpperCase()}' en ${infoHost.Host}`, "Excepciones");
  };

  const eliminarExcepcion = id => {
    const excep = demoExcepciones.find(e => e.id === id);
    if (excep) {
      logAuditAction("Eliminar", `Excepción '${excep.properties.label}' en ${excep.properties.hostName}`, "Excepciones");
    }
    setDemoExcepciones(demoExcepciones.filter(r => r.id !== id));
  };

  const colorActual = COLOR_OPTIONS.find(c => c.value === colorEtiqueta);

  /* ── Render ───────────────────────────────────── */
  if (CreateCisModalOpen) return null;

  return (
    <div className="pe-panel">

      {/* Header */}
      <div className="pe-header" onClick={() => setIsCollapsed(!isCollapsed)}>
        <span className="pe-title">Simular excepción</span>
        <div className="pe-header-right">
          {demoExcepciones.length > 0 && (
            <span className="pe-count-badge">{demoExcepciones.length}</span>
          )}
          <span className="pe-toggle">{isCollapsed ? '＋' : '－'}</span>
        </div>
      </div>

      {/* Hint siempre visible */}
      <div className="pe-hint">
        La etiqueta aparece sobre el host en el mapa al crearse.
      </div>

      {/* Cuerpo colapsable */}
      {!isCollapsed && (
        <div className="pe-body">

          {/* Formulario */}
          <div className="pe-form">
            <div className="pe-field">
              <label className="pe-label">Host</label>
              <select
                className="pe-select"
                value={selectedHost}
                onChange={e => setSelectedHost(e.target.value)}
              >
                <option value="">Seleccionar host...</option>
                {hostsDisponibles.map(h => {
                  const hasException = demoExcepciones.some(ex => ex.id.startsWith(`excep-${h.hostid}-`));
                  return (
                    <option key={h.hostid} value={h.hostid} disabled={hasException}>
                      {h.Host} {hasException ? '(Excepción activa)' : ''}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className="pe-field">
              <label className="pe-label">Etiqueta</label>
              <input
                className="pe-input"
                type="text"
                placeholder="ej: MANTTO (Max 7 caracteres)"
                maxLength={7}
                value={etiquetaTexto}
                onChange={e => setEtiquetaTexto(e.target.value)}
              />
            </div>

            <div className="pe-field">
              <label className="pe-label">Color</label>
              <div className="pe-color-row">
                {COLOR_OPTIONS.map(c => (
                  <button
                    key={c.value}
                    className={`pe-color-pill ${colorEtiqueta === c.value ? 'pe-color-pill--active' : ''}`}
                    style={{ background: c.value }}
                    title={c.label}
                    onClick={() => setColorEtiqueta(c.value)}
                  />
                ))}
                {colorActual && (
                  <span className="pe-color-name">{colorActual.label}</span>
                )}
              </div>
            </div>

            <button
              className="pe-btn-crear"
              style={{ background: colorEtiqueta }}
              onClick={crearEtiqueta}
            >
              + Crear etiqueta
            </button>
          </div>

          {/* Lista de excepciones creadas */}
          {demoExcepciones.length > 0 && (
            <div className="pe-list">
              {demoExcepciones.map(ex => (
                <div
                  key={ex.id}
                  className="pe-item"
                  style={{ borderLeft: `3px solid ${ex.properties.color}` }}
                >
                  <div className="pe-item-content">
                    <span className="pe-item-host">{ex.properties.hostName}</span>
                    <span
                      className="pe-item-badge"
                      style={{ background: ex.properties.color + '22', color: ex.properties.color }}
                    >
                      {ex.properties.label}
                    </span>
                  </div>
                  <button
                    className="pe-item-delete"
                    onClick={() => eliminarExcepcion(ex.id)}
                    title="Eliminar"
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>
          )}

        </div>
      )}
    </div>
  );
};

export default PanelExcepcion;
